import * as React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { cn } from "@/lib/utils";

export function MetricCard({ label, value, icon: Icon, trend, trendLabel, className, ...props }) {
    const positive = (trend ?? 0) >= 0;
    return (
        <div
            className={cn(
                "bg-white border border-bio-border-subtle rounded-bio-card p-6 flex flex-col justify-between shadow-bio-sm",
                className,
            )}
            {...props}
        >
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <p className="text-xs font-semibold uppercase tracking-wider text-bio-text-secondary truncate">
                        {label}
                    </p>
                    <p className="text-3xl font-extrabold text-bio-text tracking-tight mt-1 break-words">
                        {value}
                    </p>
                </div>
                {Icon && (
                    <div className="w-11 h-11 rounded-bio bg-[#EEF7FC] text-bio-primary flex items-center justify-center shrink-0">
                        <Icon className="h-5 w-5" />
                    </div>
                )}
            </div>
            {trend !== undefined && (
                <div className="mt-4 flex items-center gap-2">
                    <span
                        className={cn(
                            "inline-flex items-center gap-1 text-xs font-bold px-2 py-0.5 rounded-full",
                            positive ? "bg-[#E8F9F8] text-[#0F807B]" : "bg-[#FDECEA] text-[#B71C1C]",
                        )}
                    >
                        {positive ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
                        {positive ? "+" : ""}
                        {trend}%
                    </span>
                    {trendLabel && (
                        <span className="text-xs text-bio-text-muted truncate">{trendLabel}</span>
                    )}
                </div>
            )}
        </div>
    );
}
